/* eslint-disable jira/filename-case */
import { useHasOpened } from '@jira/software__onboarding-quickstart-has-opened/src/useHasOpened.tsx';

export const useCanShowQuickstartNudge = (): boolean => {
	const [{ hasOpened }] = useHasOpened();
	return hasOpened;
};
